import { Service } from '@/types';
import { freeSpotsOf } from '@/utils/common';

/**
 * Whether an admin can pick this slot: it has space, or it is full and the
 * service offers a waiting queue.
 *
 * Both calendars and the month day-colouring must agree on this, or a day is
 * painted "nothing here" while its slots are queue-able (or vice versa). A slot
 * with no spot count at all is not selectable — nothing is known about it.
 */
export function isSlotSelectable(
    time?: { Free?: number; FreeSpots?: number } | null,
    enableBookingQueue?: boolean
): boolean {
    const free = freeSpotsOf(time);
    if (free === undefined) return false;

    return free > 0 || (free === 0 && !!enableBookingQueue);
}

export function getPricesInfo(service: Service) {
    const hasMultiplePrices = service.Prices && service.Prices.length > 1;
    const hasGroupBooking =
        service.GroupBooking.Active && service.GroupBooking.Min !== service.GroupBooking.Max;
    const hasMultipleResource =
        service.MultipleResource.Active &&
        service.MultipleResource.Min !== service.MultipleResource.Max;

    const prices = service.Prices;
    const hasPrices = prices.length > 0;
    const maxQuantity = service.GroupBooking.Active
        ? service.GroupBooking.Max
        : service.MultipleResource.Max;
    const totalSpots = service.TotalSpots;

    return {
        hasMultiplePrices,
        hasPrices,
        hasGroupBooking,
        hasMultipleResource,
        prices,
        maxQuantity,
        totalSpots
    };
}
